module.exports = __webpack_public_path__ + "static/img/main-location-icon2.0f6f60cf.svg";